import {NgModule} from '@angular/core';
import {SuccessScreenComponent} from './success-screen.component';
import {SuccessScreenRoutingModule} from './success-screen-routing.module';
import {CommonModule} from "@angular/common";
import {LoadingModule} from "../loading/loading.module";
import {NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  imports: [SuccessScreenRoutingModule, CommonModule, LoadingModule, NgbDropdownModule],
  declarations: [SuccessScreenComponent],
  providers: []
})
export class SuccessScreenModule {
}
